<div class="mb-3">
    <label [for]="controllerName" [translate]="label"></label>

    @if(required){
    <label class="text-danger">*</label>
    }

    @if(isTextarea) {
    <textarea [id]="controllerName" class="form-control" [readonly]="disabled"
        [ngClass]="!formControl?.touched? '' : formControl?.invalid ? 'is-invalid': 'is-valid'"
        [placeholder]="label | translate" [rows]="rows" [formControl]="formControl"></textarea>
    } @else {
    <input [id]="controllerName" [type]="type" class="form-control" [readonly]="disabled"
        [ngClass]="!formControl?.touched? '' : formControl?.invalid ? 'is-invalid': 'is-valid'"
        [placeholder]="label | translate" [formControl]="formControl">
    }

    <div *ngIf="formControl?.invalid && (formControl?.touched || formControl?.dirty)" role="alert">
        @for (error of checkControllerErrors(); track $index) {
        <p class="text-danger" [translate]="error"></p>
        }

        <p class="text-danger" *ngIf="formControl?.errors['pattern']" [translate]="customError"></p>
    </div>
</div>